<template>
  <div>
    <b-form-input :formatter="mascaraValor" v-model.lazy="valueCurrency" placeholder="R$ 0,00" :value="formattedValue"></b-form-input>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    index: String,
  },
  data() {
    return {
      valueCurrency: "",
    };
  },
  methods: {
    mascaraValor(value) {
      value = value.toString().replace(/\D/g, "");
      value = value.toString().replace(/(\d)(\d{8})$/, "$1.$2");
      value = value.toString().replace(/(\d)(\d{5})$/, "$1.$2");
      value = value.toString().replace(/(\d)(\d{2})$/, "$1,$2");
      return "R$ " + value;
    },
  },
  watch: {
    valueCurrency() {
      let sendCurrency = this.valueCurrency
        .toString()
        .replace(/[.]+/g, "")
        .replace(/[,]+/g, ".")
        .replace(/[^0-9.]/g, "");
      this.$emit("onChange", sendCurrency);
    },
    value() {
      this.valueCurrency = this.mascaraValor(this.value);
    },
  },
  created() {
    this.valueCurrency = this.mascaraValor(this.value);
  },
};
</script>
